<li *ngIf="columnFilter.value"
    class="nav-item"
    ngbTooltip="This is a column filter. It only applies to this tab."
    placement="top"
    container="body"
    autoClose="outside">
      <button
          class="btn btn-sm border-dark me-1"
          [class.btn-light]="!columnFilter.isInvalid && !columnFilter.isDisabled"
          [class.btn-secondary]="!columnFilter.isInvalid && columnFilter.isDisabled"
          [class.btn-danger]="columnFilter.isInvalid"
      >
      <span
        class="text-decoration-underline-hover"
        (click)="toggleColumnFilterIsDisable()"
        *ngIf="columnFilter.isDisabled"
        placement="bottom"
        ngbTooltip="Enable filter"
      >
        <i class="fa-light fa-eye me-1"></i>
      </span>
      <span 
        class="text-decoration-underline-hover"
        (click)="toggleColumnFilterIsDisable()"
        *ngIf="!columnFilter.isDisabled"
        placement="bottom"
        ngbTooltip="Disable filter"
        > 
          <i class="fa-light fa-eye-slash me-1"></i>
        </span>
        <span [class.text-decoration-underline-hover]="!columnFilter.isDisabled"
              [class.text-decoration-filter-disabled]="columnFilter.isDisabled"y
        >
          <strong>{{columnFilter.label}}:</strong> {{columnFilter.value | truncate: 20: '...' }}
        </span>
        <span
        class="text-decoration-underline-hover"
        (click)="removeColumnFilter()"
        placement="bottom"
        ngbTooltip="Remove filter"
        >
          <i class="fa-light fa-trash-can ms-1"></i>
        </span>
      </button>
</li>